import { useEffect, useState } from "react";
import { MessageCircle, X } from "lucide-react";
import { WHATSAPP_NUMBER, buildWhatsAppUrl } from "@/lib/whatsapp";

const BUBBLES = [
  "Instant quote & free booking",
  "Reply within 60 seconds",
  "Need help? Chat with us",
];

export function WhatsAppFab() {
  const [bubbleIdx, setBubbleIdx] = useState(0);
  const [showBubble, setShowBubble] = useState(true);

  useEffect(() => {
    const t = setInterval(() => {
      setBubbleIdx((i) => (i + 1) % BUBBLES.length);
    }, 4500);
    return () => clearInterval(t);
  }, []);

  if (!WHATSAPP_NUMBER) return null;

  const href = buildWhatsAppUrl(
    "Hello Bacha Way Travel, I'd like to book a private transfer."
  );

  return (
    <div className="fixed bottom-5 right-5 z-50 flex items-end gap-3 md:bottom-7 md:right-7">
      {showBubble && (
        <div className="relative hidden sm:flex items-center gap-2 rounded-full bg-white px-4 py-2.5 pr-9 text-sm font-medium text-foreground shadow-[0_10px_30px_-10px_rgba(30,42,120,0.35)] ring-1 ring-border animate-in fade-in slide-in-from-right-2">
          <span key={bubbleIdx} className="animate-in fade-in slide-in-from-bottom-1">
            {BUBBLES[bubbleIdx]}
          </span>
          <button
            type="button"
            onClick={() => setShowBubble(false)}
            aria-label="Dismiss"
            className="absolute right-1.5 top-1/2 -translate-y-1/2 flex h-6 w-6 items-center justify-center rounded-full text-muted-foreground hover:bg-secondary"
          >
            <X className="h-3.5 w-3.5" />
          </button>
          <span className="absolute -right-1.5 top-1/2 -translate-y-1/2 h-3 w-3 rotate-45 bg-white ring-1 ring-border" />
        </div>
      )}

      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat with us on WhatsApp"
        className="group relative flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_15px_40px_-10px_rgba(37,211,102,0.7)] transition-transform hover:scale-105 md:h-16 md:w-16"
      >
        <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-60 animate-ping" aria-hidden />
        <MessageCircle className="relative h-7 w-7 md:h-8 md:w-8 fill-white" strokeWidth={1.5} />
        <span className="absolute -top-1 -right-1 flex h-5 min-w-5 items-center justify-center rounded-full bg-destructive px-1 text-[10px] font-bold text-white ring-2 ring-white">
          1
        </span>
      </a>
    </div>
  );
}
